<template>
  <div class="stock-indicator">
    <div
      v-if="showMessages"
      class="stock-indicator__wrapper"
    >
      <p
        v-if="showStockMessages"
        class="
          stock-indicator__text
          text-body-2xs
        "
        :class="{
          ['stock-indicator--available']: stockState.state === 'available',
          ['stock-indicator--low']: stockState.state !== 'available',
        }"
        v-text="stockState.message"
      />

      <p
        v-else-if="availableStock > 0"
        class="
          stock-indicator__text
          text-body-2xs
        "
        v-text="$string('product.stock_level.simple_in_stock', {
          replace: {
            amount: availableStock
          }
        })"
      />

      <p
        v-else
        class="
          stock-indicator__text
          stock-indicator--low
          text-body-2xs
        "
        v-text="$string('product.content.out_of_stock')"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Stock indicator (stock-indicator)
 * -----------------------------------------------------------------------------
 * Small component that displays available stock for a product.
 *
 */
import { mapState } from 'vuex'

export default {
  name: 'StockIndicator',

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      product: (state) => state.product.product,
      variant: (state) => state.product.variant,
    }),

    showMessages(){
      if(!this.product){
        return false
      }

      if(!this.product.hasOnlyDefaultVariant && !this.variant){
        return false
      }

      return true
    },

    showStockMessages() {
      return cnvs.settings.lowStockWarningToggle
    },

    /**
     * Returns available stock quantity.
     * @returns {Number}
     */
    availableStock() {
      return this?.variant.inventory ?? this.product?.inventory ?? 0
    },

    /**
     * Indicates a string value for stock levels.
     * @returns {String}
     */
    stockState() {
      const stock = this.availableStock

      if (stock > cnvs.settings.lowStockWarningOne) {
        return {
          state: 'available',
          message: this.$string('product.content.in_stock'),
        }
      } else if (stock <= cnvs.settings.lowStockWarningOne && stock > cnvs.settings.lowStockWarningTwo) {
        return {
            state: 'low',
            message: this.$string('product.stock_level.higher', {
            replace: {
              amount: this.availableStock,
            },
          }),
        }
      } else if (stock <= cnvs.settings.lowStockWarningTwo && stock > cnvs.settings.lowStockWarningThree) {
        return {
            state: 'low',
            message: this.$string('product.stock_level.low', {
            replace: {
              amount: this.availableStock,
            },
          }),
        }
      } else if(stock <= cnvs.settings.lowStockWarningThree && stock > 0){
        return {
            state: 'low',
            message: this.$string('product.stock_level.minimal', {
            replace: {
              amount: this.availableStock,
            },
          }),
        }
      }
      return {
        state: 'out',
        message: this.$string('product.content.out_of_stock'),
      }
    },
  },
}
</script>

<style lang="scss">
@import './stock-indicator';
</style>
